import { ReferenceKind } from '../exchange/weighbridge-exchange-api.service';

/** One generated weighbridge reference file, as « Fichiers pont bascule » lists it. */
export interface WeighbridgeFile {
  kind: ReferenceKind;
  /** The file's name at the scale: its label everywhere (a filename, not translated). */
  filename: string;
  route: string;
}

/**
 * « Fichiers pont bascule » (Données sortantes, ADEV-1207): the five generated
 * weighbridge reference files, in menu order. One list for the sidebar, Ctrl+K
 * and the file page's title.
 */
export const WEIGHBRIDGE_FILES: readonly WeighbridgeFile[] = (
  [
    ['produits', 'Produit.csv'],
    ['tiers', 'Tiers.csv'],
    ['transporteurs', 'Transporteur.csv'],
    ['contenants', 'Contenant.csv'],
    ['commandes', 'Commande.csv'],
  ] as const
).map(([kind, filename]) => ({ kind, filename, route: `/motherdb/reference-files/${kind}` }));
